import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { User } from '../../../models/user';
import { selectUser } from '../../../features/user/user.selectors';
import { Store } from '@ngrx/store';
import {
  ConfirmDialog
} from '../../../shared/dialogs/confirm-dialog/confirm.dialog';
import { ToastrService } from 'ngx-toastr';
import { MatDialog } from '@angular/material/dialog';
import { TranslocoService } from '@jsverse/transloco';
import {
  selectOrganizationTotal
} from '../../../features/organization/organization.selectors';
import {
  OrganizationDialog
} from '../../../shared/dialogs/organization-dialog/organization.dialog';
import {
  selectOrganization
} from '../../../features/organization/organization.actions';
import Keycloak from 'keycloak-js';

@Component({
    selector: 'site-list-panel',
    templateUrl: './site-list-panel.component.html',
    styleUrls: ['./site-list-panel.component.scss'],
    standalone: false
})
export class SiteListPanelComponent {

  constructor(private store: Store,
              private keycloak: Keycloak,
              private toastr: ToastrService,
              private dialog: MatDialog,
              private translocoService: TranslocoService) {
  }

  get user$(): Observable<User | undefined> {
    return this.store.select(selectUser);
  }

  get organizationCount$(): Observable<number> {
    return this.store.select(selectOrganizationTotal);
  }

  displayOrganizations(): void {
    const dialogRef = this.dialog.open(OrganizationDialog, {
      disableClose: false
    });
    dialogRef.afterClosed().subscribe(organizationId => {
      if (organizationId) {
        this.store.dispatch(selectOrganization({organizationId}));
      }
    });
  }

  logout(): void {
    const dialogRef = this.dialog.open(ConfirmDialog, {
      disableClose: false
    });
    dialogRef.componentInstance.icon = 'logout';
    dialogRef.componentInstance.title = this.translocoService.translate('logout');
    dialogRef.componentInstance.message = this.translocoService.translate('logout_message');
    dialogRef.afterClosed().subscribe(confirm => {
      if (confirm) {
        this.keycloak.logout().catch(err => this.toastr.error(err));
      }
    });
  }
}
